module.exports = __webpack_public_path__ + "img/at-home.990fc366.svg";